import { openEmailModal } from '../State/emailModal'

export default (id) => (dispatch) => {

  dispatch(openEmailModal({ id }))

}
